"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ARCHIVED = void 0;
exports.ARCHIVED = 'archived';
//# sourceMappingURL=statuses.js.map